import StatusWarningIcon from "@atlaskit/icon/core/status-warning";
import {token} from "@atlaskit/tokens";
import {twJoin} from "tailwind-merge";
import {AnankeButton} from "@vesta/ananke/components/anankeButton";
import {AnankeSkeleton} from "@vesta/ananke/components/anankeSkeleton";
import {AnankeText} from "@vesta/ananke/components/anankeText";

/** Narrow skeleton for entity profile aside (identity + tabs + cards). */
export function EntityProfileAsideLoadingState({className}: {className?: string}) {
    return (
        <div
            className={twJoin(
                "grid h-full min-h-0 w-full content-start gap-y-ds-space-150",
                "bg-ds-elevation-surface p-ds-space-250",
                className,
            )}
        >
            <div className="flex items-center justify-between gap-ds-space-100">
                <AnankeSkeleton width={140} height={18} borderRadius={3} />
                <div className="flex gap-ds-space-050">
                    <AnankeSkeleton width={28} height={28} borderRadius={3} />
                    <AnankeSkeleton width={28} height={28} borderRadius={3} />
                    <AnankeSkeleton width={28} height={28} borderRadius={3} />
                </div>
            </div>
            <AnankeSkeleton width={64} height={20} borderRadius={3} />
            <AnankeSkeleton width="70%" height={24} borderRadius={4} />
            <div className="flex gap-ds-space-100">
                <AnankeSkeleton width={120} height={28} borderRadius={4} />
                <AnankeSkeleton width={88} height={28} borderRadius={4} />
            </div>
            <div className="flex gap-ds-space-150 border-t border-solid border-ds-border pt-ds-space-150">
                {Array.from({length: 4}, (_, index) => (
                    <AnankeSkeleton key={`aside-tab-${String(index)}`} width={56} height={18} borderRadius={3} />
                ))}
            </div>
            <div className="grid gap-y-ds-space-100 pt-ds-space-100">
                <AnankeSkeleton width="100%" height={88} borderRadius={4} />
                <AnankeSkeleton width="100%" height={88} borderRadius={4} />
            </div>
        </div>
    );
}

function reloadPage(): void {
    window.location.reload();
}

/** Compact error card for entity profile aside. */
export function EntityProfileAsideErrorState({
    title = "We couldn't load the journey profile right now",
    description = "This is usually temporary. Refresh the page or try again in a few minutes.",
    onReload = reloadPage,
    className,
}: {
    title?: string;
    description?: string;
    onReload?: () => void;
    className?: string;
}) {
    return (
        <div
            className={twJoin(
                "grid h-full min-h-0 w-full place-items-center",
                "bg-ds-elevation-surface px-ds-space-200 py-ds-space-300",
                className,
            )}
        >
            <div className="grid w-full max-w-[22rem] place-items-center gap-ds-space-150 text-center">
                <div className="scale-125 [&>*>svg]:h-12! [&>*>svg]:w-12!">
                    <StatusWarningIcon label="" color={token("color.icon.danger")} />
                </div>
                <div className="grid gap-ds-space-050">
                    <AnankeText weight="bold">{title}</AnankeText>
                    <AnankeText color="color.text.subtlest">{description}</AnankeText>
                </div>
                <AnankeButton type="button" appearance="primary" onClick={onReload}>
                    Reload
                </AnankeButton>
            </div>
        </div>
    );
}
